/**
 * Carries an invitation link token across the federated first login's SAML
 * round-trip (TO-309): the public page stashes it before leaving for the IdP,
 * and `/t/:slug/invitation/complete` reads it on return, clearing it only once
 * the completion succeeds (so a transient failure can be retried by reloading).
 *
 * Per-tab sessionStorage, one-shot, keyed by tenant — the same reasoning as the
 * post-login redirect stash (`./post-login-redirect.ts`).
 */
const keyFor = (slug: string) => `invitationToken:${slug}`

export function stashInvitationToken(slug: string, token: string): void {
	sessionStorage.setItem(keyFor(slug), token)
}

/** Read and clear the stashed token for `slug`; `null` if none. */
export function consumeInvitationToken(slug: string): string | null {
	const token = sessionStorage.getItem(keyFor(slug))
	sessionStorage.removeItem(keyFor(slug))
	return token
}

/** Read the stashed token for `slug` without clearing it; `null` if none. */
export function peekInvitationToken(slug: string): string | null {
	return sessionStorage.getItem(keyFor(slug))
}
